import { MgdRoutes } from "../application/interfaces/route";
import { AuthenticationRouteId } from "./enums/authentication-route-id";
import { temporaryTokenResolver } from "./resolvers/temporary-token.resolver";
import { logoutRedirect } from "./redirects/logout.redirect";

/**
 * Routes used for Application when the app depends on Internal API
 * These routes are side-loaded with main App Routes by AppUtil.configureApplication
 *
 * @private
 */
export const IAPI_ROUTES: MgdRoutes = [
    {
        path: "login",
        data: {
            routeId: AuthenticationRouteId.Login,
        },
        loadComponent: () => import("./views/login-submit-form/login-submit-form.component").then((m) => m.LoginSubmitFormComponent)
    },
    {
        path: "logout",
        data: {
            routeId: AuthenticationRouteId.Logout
        },
        redirectTo: logoutRedirect
    },
    {
        path: "accept-invitation",
        resolve: {
            temporaryToken: temporaryTokenResolver
        },
        data: {
            routeId: AuthenticationRouteId.AcceptInvitation
        },
        loadComponent: () => import("./views/set-password-submit-form/set-password-submit-form.component").then((m) => m.SetPasswordSubmitFormComponent)
    },
    {
        path: "forgot-password",
        resolve: {
            temporaryToken: temporaryTokenResolver
        },
        data: {
            routeId: AuthenticationRouteId.ForgotPassword
        },
        loadComponent: () => import("./views/set-password-submit-form/set-password-submit-form.component").then((m) => m.SetPasswordSubmitFormComponent)
    },
    {
        path: "forgot-password-request",
        data: {
            routeId: AuthenticationRouteId.ForgotPasswordRequest
        },
        loadComponent: () => import("./views/forgot-password-submit-form/forgot-password-submit-form.component").then((m) => m.ForgotPasswordSubmitFormComponent)
    }
];
